"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = compareComponents;

// This function is responsible for comparing two components to see if they are equal
function compare(comp, imported, notEqual) {
  return notEqual ? comp !== imported : comp === imported;
}

function compareComponents(component, importedComponent) {
  var notEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (component && importedComponent) {
    if (component.displayName && importedComponent.displayName) {
      return compare(component.displayName, importedComponent.displayName, notEqual);
    }

    if (component.type && importedComponent.type) {
      return compare(component.type, importedComponent.type, notEqual);
    } // For elements wrapped in the Hot-Reloader proxy


    if (component.type && component.type.displayName && importedComponent.displayName) {
      return compare(component.type.displayName, importedComponent.displayName, notEqual);
    } // Most common in cobalt


    if (component.type && importedComponent) {
      return compare(component.type, importedComponent, notEqual);
    } // Direct comparisson


    return compare(component, importedComponent, notEqual);
  }
}